module.exports = __webpack_public_path__ + "app/img/home_4@2x.c8edadc9.png";